import { createSlice } from '@reduxjs/toolkit';
import { getAdminBillingData } from "./api";

export const adminBillingSlice = createSlice({
    name: 'adminBilling',
    initialState: {
        loading: false,
        organizations: [],
        totals: {
            totalUnits: 0,
            totalSessions: 0,
            totalOrgs: 0
        },
    },
    reducers: {},
    extraReducers: {
        [getAdminBillingData.pending]: (state) => {
            state.loading = true;
        },
        [getAdminBillingData.rejected]: (state) => {
            state.loading = false;
        },
        [getAdminBillingData.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.organizations = payload.organizations || [];
            state.totals = payload.totals || { totalUnits: 0, totalSessions: 0, totalOrgs: 0 };
        },
    }
});

const { reducer } = adminBillingSlice;

export default reducer;
